import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{ fontSize: "14px" }}>
        <Container fluid={true}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              All rights reserved © 2022-{new Date().getFullYear()}
            </div>
            <div className="d-flex">
              Design & Develop by WhiteCore Technology LLP
            </div>
          </div>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
